export default __webpack_public_path__ + "static/media/left_corner.468341cf.png";